"use strict";
exports.__esModule = true;
exports.AccessoryBuilder = exports.AccessoryType = exports.Accessory = exports.AccessoryReferenceBuilder = exports.AccessoryReference = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var AccessoryModel_1 = require("./AccessoryModel");
var AccessoryReference = /** @class */ (function () {
    function AccessoryReference() {
    }
    AccessoryReference.identical = function (c1, c2) {
        return (c1.accessoryId === c2.accessoryId && c1.accessoryModelId === c2.accessoryModelId && AccessoryModel_1.AccessoryConfiguration.identical(c1.accessoryConfiguration, c2.accessoryConfiguration));
    };
    return AccessoryReference;
}());
exports.AccessoryReference = AccessoryReference;
var AccessoryReferenceBuilder = /** @class */ (function () {
    function AccessoryReferenceBuilder(reference) {
        this.reference = reference;
    }
    AccessoryReferenceBuilder.initialise = function (accessoryId, accessoryModelId, accessoryConfiguration) {
        return new AccessoryReferenceBuilder({
            accessoryId: accessoryId,
            accessoryModelId: accessoryModelId,
            accessoryConfiguration: accessoryConfiguration
        });
    };
    AccessoryReferenceBuilder.prototype.build = function () {
        return this.reference;
    };
    return AccessoryReferenceBuilder;
}());
exports.AccessoryReferenceBuilder = AccessoryReferenceBuilder;
var Accessory = /** @class */ (function () {
    function Accessory() {
    }
    Accessory.isPublishable = function (accessory) {
        if (accessory.models.length === 0)
            return false;
        for (var _i = 0, _a = accessory.models; _i < _a.length; _i++) {
            var accessoryModel = _a[_i];
            if (!AccessoryModel_1.AccessoryModel.isPublishable(accessoryModel))
                return false;
        }
        return true;
    };
    Accessory.getAllAvailableAccessoryConfigurationsFromMultipleAccessories = function (accessories) {
        var results = [];
        for (var _i = 0, accessories_1 = accessories; _i < accessories_1.length; _i++) {
            var accessory = accessories_1[_i];
            var _loop_1 = function (accessoryConfig) {
                if (!results.find(function (pc) { return AccessoryModel_1.AccessoryConfiguration.identical(pc, accessoryConfig); })) {
                    results.push(accessoryConfig);
                }
            };
            for (var _a = 0, _b = Accessory.getAllAvailableAccessoryConfigurations(accessory); _a < _b.length; _a++) {
                var accessoryConfig = _b[_a];
                _loop_1(accessoryConfig);
            }
        }
        return results;
    };
    Accessory.getAllAvailableAccessoryConfigurations = function (accessory) {
        if (accessory.models.length === 0) {
            return [];
        }
        return accessory.models.map(function (m) { return m.availableConfigurations; }).reduce(function (c1, c2) { return c1.concat(c2); });
    };
    Accessory.getAllAccessoryWeights = function (accessory) {
        if (accessory.models.length === 0) {
            return [];
        }
        return accessory.models.map(function (m) { return m.weights; }).reduce(function (c1, c2) { return c1.concat(c2); });
    };
    Accessory.getAllAccessoryImages = function (accessory) {
        if (accessory.models.length === 0) {
            return [];
        }
        return accessory.models.map(function (m) { return m.images; }).reduce(function (c1, c2) { return c1.concat(c2); });
    };
    return Accessory;
}());
exports.Accessory = Accessory;
var AccessoryType;
(function (AccessoryType) {
    AccessoryType["NECKLACE"] = "NECKLACE";
})(AccessoryType = exports.AccessoryType || (exports.AccessoryType = {}));
var AccessoryBuilder = /** @class */ (function () {
    function AccessoryBuilder(accessory) {
        this.accessory = accessory;
    }
    AccessoryBuilder.initialiseWithAccessory = function (accessory) {
        return new AccessoryBuilder(accessory);
    };
    AccessoryBuilder.initialise = function (title, description) {
        return AccessoryBuilder.initialiseWithAccessory({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            title: title,
            type: AccessoryType.NECKLACE,
            description: description,
            models: []
        });
    };
    AccessoryBuilder.prototype.createOrReplaceAccessoryModel = function (newAccessoryModel) {
        if (this.hasAccessoryModelWithId(newAccessoryModel.id) || this.hasAccessoryModelWithSize(newAccessoryModel.sizeType)) {
            return this.deleteAccessoryModel(newAccessoryModel.id).createAccessoryModel(newAccessoryModel);
        }
        else {
            return this.createAccessoryModel(newAccessoryModel);
        }
    };
    AccessoryBuilder.prototype.hasAccessoryModelWithId = function (pieceModelId) {
        return (this.accessory.models.find(function (model) { return model.id === pieceModelId; }) !== undefined);
    };
    AccessoryBuilder.prototype.hasAccessoryModelWithSize = function (sizeType) {
        return (this.accessory.models.find(function (model) { return (model.sizeType === sizeType); }) !== undefined);
    };
    AccessoryBuilder.prototype.createAccessoryModel = function (newAccessoryModel) {
        if (this.hasAccessoryModelWithId(newAccessoryModel.id))
            throw new core_common_domain_1.Exception("Cannot update the accessory to add model with id " + newAccessoryModel.id + " because a model with the same id already exists");
        if (this.hasAccessoryModelWithSize(newAccessoryModel.sizeType))
            throw new core_common_domain_1.Exception("Cannot update the accessory to add model " + JSON.stringify(newAccessoryModel) + " because a model with the same sizeType already exists");
        this.accessory.models.push(newAccessoryModel);
        return this;
    };
    AccessoryBuilder.prototype.deleteAccessoryModel = function (accessoryModelId) {
        if (!this.hasAccessoryModelWithId(accessoryModelId))
            throw new core_common_domain_1.Exception("Cannot update the accessory to remove model with id " + accessoryModelId + " because it cannot be found inside the accessory " + this.getId());
        this.accessory.models = this.accessory.models.filter(function (model) { return model.id !== accessoryModelId; });
        return this;
    };
    AccessoryBuilder.prototype.removeAllAccessoryModels = function () {
        this.accessory.models = [];
        return this;
    };
    AccessoryBuilder.prototype.withId = function (id) {
        this.accessory.id = id;
        return this;
    };
    AccessoryBuilder.prototype.getId = function () {
        return this.accessory.id;
    };
    AccessoryBuilder.prototype.build = function () {
        return this.accessory;
    };
    AccessoryBuilder.prototype.buildUpdate = function () {
        return {
            type: this.accessory.type,
            title: this.accessory.title,
            description: this.accessory.description,
            models: this.accessory.models
        };
    };
    return AccessoryBuilder;
}());
exports.AccessoryBuilder = AccessoryBuilder;
